<template>
   <div id="recaudos">
      <div v-if="loading" id="loading" class="loading_full">Loading&#8230;</div>
      <div class="card">
         <div class="card-body">
            <h4 class="fw-bolder mb-4">Recaudos</h4>
            <div class="mb-3">
               <div class="input-group">
                  <input
                     v-model="search"
                     type="text"
                     class="form-control"
                     placeholder="Buscar recaudos..."
                     @keyup.enter="buscar"
                  />
                  <button @click="buscar" class="btn btn-primary" type="button">
                     <i class="fa fa-search"></i>
                  </button>
                  <button
                     v-if="search"
                     @click="limpiarBusqueda"
                     class="btn btn-secondary"
                     type="button"
                  >
                     <i class="fa fa-times"></i> Limpiar
                  </button>
               </div>
            </div>
            <div class="row mb-3">
               <div class="col-md-3">
                  <label class="form-label fw-bold">Filtrar por</label>
                  <select v-model="filterDateType" class="form-select">
                     <option value="fecha_reg">Fecha de Registro</option>
                     <option value="fecha_actividad">Fecha de Actividad</option>
                  </select>
               </div>
               <div class="col-md-3">
                  <label class="form-label fw-bold">Desde</label>
                  <input
                     v-model="filterDateFrom"
                     type="date"
                     class="form-control"
                  />
               </div>
               <div class="col-md-3">
                  <label class="form-label fw-bold">Hasta</label>
                  <input
                     v-model="filterDateTo"
                     type="date"
                     class="form-control"
                  />
               </div>
               <div class="col-md-3 d-flex align-items-end">
                  <button
                     @click="aplicarFiltroFecha"
                     class="btn btn-info btn-sm me-2 w-100"
                  >
                     <i class="fa fa-filter"></i> Aplicar
                  </button>
                  <button
                     v-if="filterDateFrom || filterDateTo"
                     @click="limpiarFiltroFecha"
                     class="btn btn-secondary btn-sm w-100"
                  >
                     <i class="fa fa-times"></i>
                  </button>
               </div>
            </div>
            <div>
               <div>
                  <div
                     v-if="recaudos.length != 0"
                     class="table-responsive mt-3"
                  >
                     <div class="mb-3 text-end">
                        <button
                           v-if="Object.keys(recaudosSeleccionados).length > 0"
                           @click="confirmarEliminarRecaudosMasivos"
                           class="btn btn-danger btn-sm rounded-pill"
                        >
                           <i class="fa fa-trash"></i> Eliminar
                           {{ Object.keys(recaudosSeleccionados).length }}
                           seleccionado(s)
                        </button>
                     </div>
                     <table class="table table-striped table-hover">
                        <thead class="table-primary">
                           <tr>
                              <th class="text-center" style="width: 2%">
                                 <input
                                    type="checkbox"
                                    @change="toggleSeleccionarTodos"
                                    :checked="
                                       recaudos.length > 0 &&
                                       Object.keys(recaudosSeleccionados)
                                          .length === recaudos.length
                                    "
                                 />
                              </th>
                              <th class="text-center" style="width: 2%">#</th>
                              <th class="text-center" style="width: 12%">
                                 Fecha Registro
                              </th>
                              <th class="text-center">Cliente</th>
                              <th class="text-center" style="width: 30%">
                                 Descripción
                              </th>
                              <th class="text-center">Usuario</th>
                              <th class="text-center">Valor</th>
                              <th class="text-center">Cuenta</th>
                              <th>Opciones</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr
                              v-for="recaudo in recaudos"
                              :key="recaudo.id_recaudo"
                           >
                              <td class="text-center">
                                 <input
                                    type="checkbox"
                                    @change="toggleSeleccionRecaudo(recaudo)"
                                    :checked="
                                       recaudosSeleccionados[recaudo.id_recaudo]
                                    "
                                 />
                              </td>
                              <td class="text-center">
                                 <strong>{{ recaudo.num }}</strong>
                              </td>
                              <td class="text-center">
                                 {{ formatDate(recaudo.fecha_reg, 1) }}
                              </td>
                              <td class="text-uppercase">
                                 {{ recaudo.cliente }}
                              </td>
                              <td class="text-uppercase">
                                 <input
                                    v-if="
                                       editMode &&
                                       recaudoSel?.id_recaudo ===
                                          recaudo.id_recaudo
                                    "
                                    type="text"
                                    v-model="recaudo.descripcion"
                                    @keyup.enter="updateRecaudo"
                                    @keyup.esc="
                                       (editMode = false), (recaudoSel = null)
                                    "
                                    class="form-control form-control-sm fw-bold p-1"
                                 />
                                 <span
                                    v-else
                                    @dblclick="
                                       (editMode = true), (recaudoSel = recaudo)
                                    "
                                    class="fw-bold"
                                    title="Doble clic para editar"
                                    >{{ recaudo.descripcion }}</span
                                 >

                                 <div>
                                    <small>
                                       Cod. Reserva: {{ recaudo.cod_reserva }}
                                    </small>
                                    <br />
                                    <small>
                                       Servicio:
                                       {{ recaudo.servicio }}</small
                                    >
                                    <br />
                                    <small>
                                       Fecha de Actividad:
                                       {{ recaudo.fecha_actividad }}</small
                                    >
                                 </div>
                              </td>
                              <td class="text-uppercase">
                                 {{ recaudo.usuario }}
                              </td>
                              <td class="fw-bold text-success text-end">
                                 <money
                                    v-if="
                                       editMode &&
                                       recaudoSel?.id_recaudo ===
                                          recaudo.id_recaudo
                                    "
                                    @keyup.native.enter="updateRecaudo"
                                    @keyup.native.esc="
                                       (editMode = false), (recaudoSel = null)
                                    "
                                    v-model="recaudo.valor"
                                    class="form-control text-end p-1 fw-bold"
                                    v-bind="money"
                                    required
                                 ></money>
                                 <span
                                    v-else
                                    @dblclick="
                                       (editMode = true), (recaudoSel = recaudo)
                                    "
                                 >
                                    ${{ formatCurrency(recaudo.valor) }}
                                 </span>
                              </td>

                              <td class="text-uppercase">
                                 {{ recaudo.cuenta }}
                              </td>
                              <td class="text-center">
                                 <button
                                    @click="confirmarEliminarRecaudo(recaudo)"
                                    class="btn btn-danger btn-sm btn-rounded"
                                    title="Eliminar recaudo"
                                 >
                                    <i class="fa fa-trash"></i>
                                 </button>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                     <nav class="mt-4" aria-label="Paginación">
                        <ul class="pagination justify-content-center">
                           <li
                              class="page-item"
                              :class="{ disabled: page === 1 }"
                           >
                              <a
                                 class="page-link"
                                 href="#"
                                 @click.prevent="previousPage"
                              >
                                 Anterior
                              </a>
                           </li>
                           <li
                              v-for="pageNum in totalPages"
                              :key="pageNum"
                              class="page-item"
                              :class="{ active: page === pageNum }"
                           >
                              <a
                                 class="page-link"
                                 href="#"
                                 @click.prevent="changePage(pageNum)"
                              >
                                 {{ pageNum }}
                              </a>
                           </li>
                           <li
                              class="page-item"
                              :class="{ disabled: page === totalPages }"
                           >
                              <a
                                 class="page-link"
                                 href="#"
                                 @click.prevent="nextPage"
                              >
                                 Siguiente
                              </a>
                           </li>
                        </ul>
                     </nav>
                     <div class="text-center text-muted mt-2">
                        <small> Página {{ page }} de {{ totalPages }} </small>
                     </div>
                  </div>
                  <div v-else>
                     <div class="text-muted">
                        <i class="fa-solid fa-circle-info"></i> No se han
                        agregado recaudos.
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
   name: "Recaudos",
   metaInfo: {
      title: "Recaudos - Backoffice",
   },
   data() {
      return {
         loading: true,
         page: 1,
         search: null,
         recaudoSel: null,
         recaudos: [],
         totalPages: 1,
         perPage: 20,
         recaudosSeleccionados: {},
         filterDateType: "fecha_reg",
         filterDateFrom: null,
         filterDateTo: null,
         editMode: false,
         money: {
            decimal: ",",
            thousands: ".",
            prefix: "$ ",
            suffix: "",
            precision: 0,
            masked: false,
         },
      };
   },
   props: {
      session: Object,
   },
   created: function () {
      this.getRecaudos();
   },
   methods: {
      getRecaudos: function () {
         const vm = this;
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
            params: {
               page: this.page,
               search: this.search,
            },
         };

         // Agregar parámetros de fecha si existen
         if (this.filterDateFrom) {
            config.params.dateFrom = this.filterDateFrom;
            config.params.dateType = this.filterDateType;
         }
         if (this.filterDateTo) {
            config.params.dateTo = this.filterDateTo;
            config.params.dateType = this.filterDateType;
         }

         axios
            .get(vm.$base_url + "reservas/recaudos", config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  vm.recaudos = response.data.data.recaudos;
                  vm.totalPages = response.data.data.totalPages;
                  vm.recaudosSeleccionados = {};
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Recaudos",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Recaudos",
                  text: error,
               });
               vm.loading = false;
            });
      },
      formatDate: function (dateString, withTime) {
         if (!dateString) return "";
         const date = new Date(dateString);
         const datePart = date.toLocaleDateString("es-ES", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
         });
         if (withTime) {
            const timePart = date.toLocaleTimeString("es-ES", {
               hour: "2-digit",
               minute: "2-digit",
            });
            return datePart + " " + timePart;
         }
         return datePart;
      },
      formatCurrency: function (value) {
         if (!value) return "0";
         return Number(value).toLocaleString("es-ES");
      },
      changePage: function (newPage) {
         if (newPage >= 1 && newPage <= this.totalPages) {
            this.page = newPage;
            this.getRecaudos();
         }
      },
      previousPage: function () {
         this.changePage(this.page - 1);
      },
      nextPage: function () {
         this.changePage(this.page + 1);
      },
      updateRecaudo: function () {
         const vm = this;
         const recaudo = vm.recaudoSel;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            idRecaudo: recaudo.id_recaudo,
            descripcion: recaudo.descripcion,
            valor: recaudo.valor,
         };
         axios
            .post(vm.$base_url + "reservas/updateRecaudo", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Éxito",
                     text: response.data.message,
                  });
                  vm.getRecaudos();
                  vm.editMode = false;
                  vm.recaudoSel = null;
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            });
      },
      confirmarEliminarRecaudo: function (recaudo) {
         this.$swal
            .fire({
               title: "",
               html:
                  "¿Está seguro que desea eliminar el recaudo <strong>" +
                  recaudo.descripcion +
                  "</strong>?",
               icon: "question",
               showCancelButton: true,
               buttonsStyling: false,
               confirmButtonText: "Sí",
               cancelButtonText: "No",
               customClass: {
                  confirmButton: "btn btn-danger rounded-pill me-2",
                  cancelButton: "btn btn-light rounded-pill",
               },
            })
            .then((result) => {
               if (result.isConfirmed) {
                  this.deleteRecaudo(recaudo);
               }
            });
      },
      deleteRecaudo: function (recaudo) {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            idRecaudo: recaudo.id_recaudo,
         };
         axios
            .post(vm.$base_url + "reservas/deleteRecaudo", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Éxito",
                     text: response.data.message,
                  });
                  vm.getRecaudos();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            });
      },
      toggleSeleccionRecaudo: function (recaudo) {
         if (this.recaudosSeleccionados[recaudo.id_recaudo]) {
            this.$delete(this.recaudosSeleccionados, recaudo.id_recaudo);
         } else {
            this.$set(this.recaudosSeleccionados, recaudo.id_recaudo, true);
         }
      },
      toggleSeleccionarTodos: function () {
         if (
            Object.keys(this.recaudosSeleccionados).length ===
            this.recaudos.length
         ) {
            this.recaudosSeleccionados = {};
         } else {
            const seleccionados = {};
            this.recaudos.forEach((recaudo) => {
               seleccionados[recaudo.id_recaudo] = true;
            });
            this.recaudosSeleccionados = seleccionados;
         }
      },
      confirmarEliminarRecaudosMasivos: function () {
         this.$swal
            .fire({
               title: "",
               html:
                  "¿Está seguro que desea eliminar los <strong>" +
                  Object.keys(this.recaudosSeleccionados).length +
                  " recaudo(s)</strong> seleccionado(s)?",
               icon: "question",
               showCancelButton: true,
               buttonsStyling: false,
               confirmButtonText: "Sí",
               cancelButtonText: "No",
               customClass: {
                  confirmButton: "btn btn-danger rounded-pill me-2",
                  cancelButton: "btn btn-light rounded-pill",
               },
            })
            .then((result) => {
               if (result.isConfirmed) {
                  this.deleteRecaudosMasivos();
               }
            });
      },
      deleteRecaudosMasivos: function () {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let params = {
            recaudos: Object.keys(vm.recaudosSeleccionados),
         };
         axios
            .post(vm.$base_url + "reservas/deleteRecaudosMasivos", params, {
               headers: headers,
            })
            .then((response) => {
               if (!response.data.status) {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Error",
                     text: response.data.message,
                  });
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "success",
                     title: "Éxito",
                     text: response.data.message,
                  });
                  vm.recaudosSeleccionados = {};
                  vm.getRecaudos();
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Error",
                  text: error,
               });
            });
      },
      buscar: function () {
         this.page = 1;
         this.getRecaudos();
      },
      limpiarBusqueda: function () {
         this.search = null;
         this.page = 1;
         this.getRecaudos();
      },
      aplicarFiltroFecha: function () {
         if (!this.filterDateFrom && !this.filterDateTo) {
            this.$notify({
               group: "foo",
               type: "warning",
               title: "Advertencia",
               text: "Debes seleccionar al menos una fecha.",
            });
            return;
         }
         this.page = 1;
         this.getRecaudos();
      },
      limpiarFiltroFecha: function () {
         this.filterDateFrom = null;
         this.filterDateTo = null;
         this.filterDateType = "fecha_reg";
         this.page = 1;
         this.getRecaudos();
      },
   },
};
</script>
